
<p-accordion>
  <p-accordionTab header="Controles Internos" >
    <p-header style="font-weight:bolder;font-size:20px">
      Mensais
    </p-header>
    <app-lista-arquivos [miniMode]="true" categoria="notasMensais"></app-lista-arquivos>
  </p-accordionTab>

  <p-accordionTab header="Controles Internos">
    <p-header style="font-weight:bolder;font-size:20px">
      Anuais
    </p-header>
    <app-lista-arquivos [miniMode]="true" categoria="notasexplicativas"></app-lista-arquivos>
  </p-accordionTab>
<p-accordion>
